export const PAGE_NAME = {
    COMPLETE: 'complete',
    ERROR: 'error',
    START: 'start'
};
